module.exports = __webpack_public_path__ + "static/media/sportsjersey-01.cd81360d.svg";